'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MediaLeft = require('react-bootstrap/lib/MediaLeft');

var _MediaLeft2 = _interopRequireDefault(_MediaLeft);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MediaLeft2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/MediaLeft.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/MediaLeft.js
 ** module chunks = 0
 **/